import { Service, signal } from '@angular/core';
import type { LoggedInUser } from '@models/user';
import type { ProjectContext } from '@models/project-context.model';

@Service()
export class DataContext {
  readonly loggedInUser = signal<LoggedInUser | null>(null);
  readonly projectContext = signal<ProjectContext | null>(null);
  /** Shown as "Sist åpnet" in the services list (session only). */
  readonly lastOpenedServiceId = signal<string>('');

  setLoggedInUser(user: LoggedInUser): void {
    this.loggedInUser.set(user);
  }

  setProjectContext(context: ProjectContext | null): void {
    this.projectContext.set(context);
  }

  clearUser(): void {
    this.loggedInUser.set(null);
  }

  clearProjectContext(): void {
    this.projectContext.set(null);
  }
}
